export const REDUCER_NAME = "facebookLeadsSlice";

export interface IFacebookLead {
  id: string;
  vendorId: string;
  leadId?: string;
  formId?: string;
  adId?: string;
  adsetId?: string;
  campaignId?: string;
  pageId?: string;
  fullName?: string;
  email?: string;
  phone?: string;
  fieldData?: Record<string, string>;
  status: 'new' | 'contacted' | 'converted' | 'lost';
  notes?: string;
  created_at: string;
  updated_at: string;
}

export interface IFacebookLeadsState {
  isLoading: boolean;
  leads: IFacebookLead[];
  total: number;
  page: number;
  limit: number;
  errorMessage: string | null;
  syncLoading: boolean;
}

export interface ISyncLeadsDTO {
  formId: string;
}

export interface IUpdateLeadDTO {
  id: string;
  status?: string;
  notes?: string;
}
